
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
  AppBar,
  Button,
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
  Theme,
  ToggleButton,
  ToggleButtonGroup,
  Toolbar,
  Typography,
  Menu,
  FormGroup,
  Divider,
} from '@mui/material';
import { createStyles, makeStyles, useTheme } from '@mui/styles';
import ro from 'date-fns/locale/ro';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import logo from '../assets/images/logo_secom.svg';
import ErrorModal from '../components/ErrorModal';
import { modalType, sourceOptions } from '../constants/constants';
import { formValidations } from '../constants/validations';
import { useStateContext } from '../state/StateContext';
import TextModal from '../components/TextModal';
import { MESSAGES } from '../assets/messages';
import { useAuthContext } from '../auth/AuthContext';
import { createCard } from '../providers/createCard.service';
import { ICreateCard } from '../interfaces/card.interface';
import SuccessModal from '../components/SuccessModal';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react';
import { SPECIALIZATIONS } from '../constants/specializations.constants';
import { Dayjs } from 'dayjs';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex !important',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: '3rem',
      padding: 0,
      paddingTop: '4rem',
    },
    toolbar: {
      justifyContent: 'center',
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      width: '80%',
      height: '100%',
      padding: '2rem',
      paddingTop: 0,
      paddingBottom: 0,
      alignItems: 'center',
      justifyContent: 'start',
      margin: '0',
      marginTop: '2rem',
      overflow: 'visible !important',
    },

    cardContent: {
      width: '80%',
      paddingTop: '0!important',
      paddingBottom: '0!important',
    },
    formGrid: {
      width: '100%',
      padding: '1rem 0!important',
    },
    input: {
      width: '100%',
    },
    subInput: {
      width: '50%',
    },
    formButton: {
      width: '100%',
    },
    labelText: {
      color: theme.palette.primary.main,
    },
    toolbarButton: {
      width: '5rem',
      backgroundColor: 'white!important',
    },
    logoContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexGrow: 1,
    },
    toolbarButtonContainer: {
      position: 'absolute',
      right: '24px',
    },
    checkLabel: {
      margin: 0,
    },
    location: {
      fontSize: '0.9rem !important',
      fontWeight: '500 !important',
      paddingLeft: '6px !important',
      paddingRight: '6px !important',
    },
  })
);

const CreateMembership = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { setAuthState } = useAuthContext();
  const [gender, setGender] = useState('M');
  const { counties } = useStateContext();
  const [selectedCounty, setSelectedCounty] = useState<string>();
  const [tos, setTos] = useState<boolean>(false);
  const [marketing, setMarketing] = useState<boolean>(false);
  const [marketingByEmail, setMarketingByEmail] = useState<boolean>(false);
  const [marketingByPhone, setMarketingByPhone] = useState<boolean>(false);
  const [postError, setPostError] = useState<string>('');
  const [detailsType, setDetailsType] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const {
    handleSubmit,
    control,
    reset,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const formatDate = (newDate: Dayjs): string => {
    let date: Date = newDate.toDate();
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const onReset = () => {
    reset();
    setGender('M');
    setTos(false);
    setMarketing(false);
    setSelectedCounty('');
  };

  const onCheckTos = () => {
    if (!tos && errors['tos']) {
      clearErrors('tos');
    }
    setTos(!tos);
  };

  useEffect(() => {
    clearErrors('marketing')
  }, [marketing, marketingByEmail, marketingByPhone])

  useEffect(() => {
    setMarketingByEmail(false);
    setMarketingByPhone(false);
  }, [marketing])

  const onSubmit = (data: any) => {
    if (!tos) {
      setError('tos', {
        type: 'custom',
        message: 'card.tos.required',
      });
    }
    else if (!data.birthday) {
      setError('birthday', {
        type: 'custom',
        message: 'card.birthday.required',
      });
    }
    else if (!data.email) {
      setError('email', {
        type: 'custom',
        message: 'card.email.required',
      });

    } else if (marketing && !(marketingByEmail || marketingByPhone)) {
      setError('marketing', {
        type: 'custom',
        message: 'card.marketing.form.required',
      });
    } else {
      setIsLoading(true);

      const payload: ICreateCard = {
        fidelityCardNo: data.cardNumber,
        firstName: data.firstName,
        lastName: data.lastName,
        birthday: formatDate(data.birthday),
        sex: gender,
        phone: data.phoneNumber,
        county: data.county,
        city: data.city,
        accepts_tc: tos,
        marketing,
        marketingByEmail,
        marketingByPhone,
        email: data.email,
        specialization: data.specialization
      };

      createCard(payload)
        .then(() => {
          setIsLoading(false);
          setSuccess(true);
          onReset();
        })
        .catch((error) => {
          setIsLoading(false);
          if (error?.response?.data?.message) {
            setPostError(error?.response?.data?.message);
          } else {
            if (!navigator.onLine) {
              setPostError(MESSAGES[`error.internet.access` as string]);
            } else {
              setPostError(MESSAGES[`error.500` as string]);
            }
          }

        });
    }
  };

  const logout = () => {
    handleClose();
    onReset();
    localStorage.clear();
    setAuthState({});
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Backdrop open={isLoading} style={{ zIndex: 1101 }}>
        <CircularProgress color="primary" />
      </Backdrop>
      <AppBar>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logoContainer}>
            <img src={logo} alt="Secom" />
          </div>
          <div className={classes.toolbarButtonContainer}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="info"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        <Typography variant="h3" style={{ textAlign: 'center' }}>Formular înscriere Secom Professionals</Typography>
        <Card className={classes.card}>
          <div className={classes.cardContent}>
            <FormControl className={classes.formGrid}>
              <Grid container spacing={1.7}>
                <Grid xs={12} item>
                  <Controller
                    name="cardNumber"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.cardNumber}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        onChange={onChange}
                        value={value}
                        type="tel"
                        label={MESSAGES['card.number']}
                        variant="outlined"
                        className={classes.input}
                        error={errors['cardNumber'] && true}
                        helperText={errors['cardNumber']?.message ? MESSAGES[errors['cardNumber'].message as string] : undefined}
                      />
                    )}
                  />
                </Grid>
                <Grid xs={6} item>
                  <Controller
                    name="lastName"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.lastName}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        onChange={onChange}
                        value={value}
                        label={MESSAGES['card.lastName']}
                        variant="outlined"
                        className={classes.input}
                        error={errors['lastName'] && true}
                        helperText={errors['lastName']?.message ? MESSAGES[errors['lastName'].message as string] : undefined}
                      />
                    )}
                  />
                </Grid>
                <Grid xs={6} item>
                  <Controller
                    name="firstName"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.firstName}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        onChange={onChange}
                        value={value}
                        label={MESSAGES['card.firstName']}
                        variant="outlined"
                        className={classes.input}
                        error={errors['firstName'] && true}
                        helperText={errors['firstName']?.message ? MESSAGES[errors['firstName'].message as string] : undefined}
                      />
                    )}
                  />
                </Grid>
                <Grid xs={12} item>
                  <Controller
                    name="email"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.email}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        onChange={onChange}
                        value={value}
                        label={MESSAGES['card.email']}
                        variant="outlined"
                        className={classes.input}
                        error={errors['email'] && true}
                        helperText={errors['email']?.message ? MESSAGES[errors['email'].message as string] : undefined}
                      />
                    )}
                  />
                </Grid>
                <Grid xs={6} item>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                  >
                    <Controller
                      name="birthday"
                      defaultValue={null}
                      control={control}
                      rules={formValidations.birthDate}
                      render={({ field: { onChange, value } }) => (
                        <DatePicker
                          format="DD/MM/YYYY"
                          disableFuture
                          label={MESSAGES['card.birthday']}
                          value={value}
                          onChange={(newDate: Dayjs | null) => {
                            onChange(newDate);
                          }}
                          slotProps={{
                            textField: {
                              helperText: errors['birthday']?.message ? MESSAGES[errors['birthday'].message as string] : undefined,
                              error: errors['birthday'] && true
                            }
                          }}
                          className={classes.input}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid xs={6} item>
                  <ToggleButtonGroup
                    value={gender}
                    exclusive
                    onChange={(e, newGender) => {
                      if (newGender) {
                        setGender(newGender);
                      }
                    }}
                    className={classes.input}
                    style={{ height: '100%' }}
                  >
                    <ToggleButton value="M" className={classes.subInput}>
                      {MESSAGES['card.gender.male']}
                    </ToggleButton>
                    <ToggleButton value="F" className={classes.subInput}>
                      {MESSAGES['card.gender.female']}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
                <Grid xs={12} item>
                  <Controller
                    name="phoneNumber"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.phoneNumber}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        type="tel"
                        onChange={onChange}
                        value={value}
                        label={MESSAGES['card.phone']}
                        variant="outlined"
                        className={classes.input}
                        error={errors['phoneNumber'] && true}
                        helperText={errors['phoneNumber']?.message ? MESSAGES[errors['phoneNumber'].message as string] : undefined}
                      />
                    )}
                  />
                </Grid>


                <Grid xs={6} item>
                  <Controller
                    name="county"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.county}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label={MESSAGES['card.county']}
                        value={value}
                        onChange={(e) => {
                          setSelectedCounty(e.target.value);
                          onChange(e);
                        }}
                        className={classes.input}
                        select
                        error={errors['county'] && true}
                        helperText={errors['county']?.message ? MESSAGES[errors['county'].message as string] : undefined}
                      >
                        {counties?.map((county: any) => {
                          return (
                            <MenuItem
                              value={county.name}
                              key={`countyOption${county.id}`}
                            >
                              {county.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid xs={6} item>
                  <Controller
                    name="city"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.city}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label={MESSAGES['card.city']}
                        value={value}
                        onChange={onChange}
                        className={classes.input}
                        select
                        error={errors['city'] && true}
                        helperText={errors['city']?.message ? MESSAGES[errors['city'].message as string] : undefined}
                      >
                        {selectedCounty ? (
                          counties
                            ?.find(
                              (county: any) => county.name === selectedCounty
                            )
                            .cities?.map((city: any) => {
                              return (
                                <MenuItem
                                  value={city.name}
                                  key={`cityOption${city.id}`}
                                >
                                  {city.name}
                                </MenuItem>
                              );
                            })
                        ) : (
                          <MenuItem value={''} key={``}>
                            {''}
                          </MenuItem>
                        )}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid xs={12} item>
                  <Controller
                    name="specialization"
                    defaultValue={''}
                    control={control}
                    rules={formValidations.specialization}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label={MESSAGES['card.specialization']}
                        value={value}
                        onChange={(e: any) => {
                          onChange(e);
                        }}
                        className={classes.input}
                        select
                        error={errors['specialization'] && true}
                        helperText={errors['specialization']?.message ? MESSAGES[errors['specialization'].message as string] : undefined}
                      >
                        {SPECIALIZATIONS.map((option: any) => {
                          return (
                            <MenuItem value={option} key={`option${option}`}>
                              {option}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid xs={12} item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tos}
                        onChange={onCheckTos}
                        size="medium"
                      />
                    }
                    label={
                      <>
                        <p className={classes.checkLabel}>
                          {MESSAGES['card.tos.label'].split('{}')[0]}
                          <span
                            className={classes.labelText}
                            onClick={(e: any) => {
                              e.preventDefault();
                              setDetailsType(modalType.TOS);
                            }}
                          >
                            {MESSAGES['card.tos']}
                          </span>
                          {MESSAGES['card.tos.label'].split('{}')[1]}
                        </p>
                        <FormHelperText
                          error={errors['tos'] && true}
                          style={{ marginLeft: 0 }}
                        >
                          {MESSAGES[errors['tos']?.message as string]}
                        </FormHelperText>
                      </>
                    }
                  />
                </Grid>
                <Grid xs={12} item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={marketing}
                        onChange={setMarketing.bind(null, !marketing)}
                        size="medium"
                      />
                    }
                    label={
                      <p className={classes.checkLabel}>
                        {MESSAGES['card.marketing.label']}
                        <span
                          className={classes.labelText}
                          onClick={(e: any) => {
                            e.preventDefault();
                            setDetailsType(modalType.MARKETING);
                          }}
                        >
                          {MESSAGES['card.marketing']}
                        </span>
                      </p>
                    }
                  />
                </Grid>
                <Divider style={{ width: '100%', paddingTop: '1rem' }} />
                <Grid xs={12} item>
                  <p className={classes.checkLabel}>Cum vrei sa primesti informări în scopuri de marketing direct si oferte personalizate?</p>
                  <FormGroup sx={{ flexDirection: 'row', paddingTop: '1rem', justifyContent: 'center' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={marketingByEmail}
                          disabled={!marketing}
                          onChange={setMarketingByEmail.bind(null, !marketingByEmail)}
                          size="medium"
                        />
                      }
                      label={
                        <p className={classes.checkLabel}>
                          {MESSAGES['card.marketing.byEmail']}
                        </p>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={marketingByPhone}
                          disabled={!marketing}
                          onChange={setMarketingByPhone.bind(null, !marketingByPhone)}
                          size="medium"
                        />
                      }
                      label={
                        <p className={classes.checkLabel}>
                          {MESSAGES['card.marketing.byPhone']}
                        </p>
                      }
                    />
                    <FormHelperText
                      error={errors['marketing'] && true}
                      style={{ marginLeft: 0 }}
                    >
                      {MESSAGES[errors['marketing']?.message as string]}
                    </FormHelperText>
                  </FormGroup>
                </Grid>
                <Grid xs={6} item>
                  <Button
                    variant="text"
                    onClick={onReset}
                    color="error"
                    className={classes.formButton}
                  >
                    {MESSAGES['card.reset']}
                  </Button>
                </Grid>
                <Grid xs={6} item>
                  <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit)}
                    className={classes.formButton}
                    style={{ color: 'white' }}
                  >
                    {MESSAGES['card.confirm']}
                  </Button>
                </Grid>
              </Grid>
            </FormControl>
          </div>
        </Card>
      </Container >
      <ErrorModal error={postError} onClose={setPostError.bind(null, '')} />
      <TextModal
        variant={detailsType}
        onClose={setDetailsType.bind(null, '')}
      />
      <SuccessModal open={success} onClose={setSuccess.bind(null, false)} />
    </>
  );
};

export default CreateMembership;
